<template>
  <CFooter :fixed="false">
<!--    <div>-->
<!--&lt;!&ndash;      <a href="https://coreui.io" target="_blank">CoreUI</a>&ndash;&gt;-->
<!--&lt;!&ndash;      <span class="ml-1">&copy; {{new Date().getFullYear()}} creativeLabs.</span>&ndash;&gt;-->

<!--      <CRow>-->
<!--        <CCol>-->
<!--          <span class="ml-1">&copy; {{new Date().getFullYear()}} Personnel Division Mae Fah Luang University</span><br>-->
<!--          โทรศัพท์. 0 5391 6020-->
<!--        </CCol>-->
<!--      </CRow>-->
<!--    </div>-->
<!--    <div class="ml-auto">-->
<!--&lt;!&ndash;      <span class="mr-1" target="_blank">Powered by</span>&ndash;&gt;-->
<!--&lt;!&ndash;      <a href="https://coreui.io/vue">CoreUI for Vue</a>&ndash;&gt;-->
<!--      <CRow>-->
<!--        <CCol>-->
<!--          ส่วนการเจ้าหน้าที่ มหาวิทยาลัยแม่ฟ้าหลวง <br>-->
<!--          สำนักงานบริหารกลาง (AD2) มหาวิทยาลัยแม่ฟ้าหลวง-->
<!--        </CCol>-->
<!--      </CRow>-->
<!--    </div>-->
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
